import { COUNTRIES, COUNTRIES_DOMAINS_REGEXP, DEFAULT_COUNTRY, DOMAIN_COUNTRY_CODES, } from '../constants/domain';
import { CountryCode } from '~shared/constants';

const countriesList = Object.keys(COUNTRIES);

  export function getHost (request) {
    let host = (!!request?.headers && (request?.headers['x-forwarded-host'] || request?.headers['host']));

    if (!host) {
      host = window?.location?.host;
    }
    return host.replace(/(:\d+)$/, ''); // omit port
  }

  export function getCountryFromHost (host) {
    const country = countriesList.find((value) => {
      return COUNTRIES_DOMAINS_REGEXP[`${value}_DOMAINS_REGEXP`].some(regExp => regExp.test(host));
    });

    return country || DEFAULT_COUNTRY;
  }

  export function getCountryCode (country) {
    return DOMAIN_COUNTRY_CODES[country];
  }

  export function getCountryDomainCode (request?): CountryCode {
    /* request is an optional parameter because this function can work in NodeJS and in browser contexts.
       This request is the web-app-buyer request. Which means it's not needed when We call this function from browser
       context. But We need to make sure 100% when calling it.
    */
    const host = getHost(request);
    const country = getCountryFromHost(host);
    return getCountryCode(country) || CountryCode.Germany;
  }

